import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaymentTypeLabelPipe } from './payment-type-label.pipe';

@NgModule({
  declarations: [PaymentTypeLabelPipe],
  imports: [CommonModule],
  exports: [PaymentTypeLabelPipe]
})
export class PaymentTypeLabelPipeModule {}
